import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <Nav>
      <Logo>
        <img src="images/connectkgp.png" alt="ConnectKGP" />
        <span>ConnectKGP</span>
      </Logo>
      <NavMenu>
        <NavLink to="/dashboard">
          <i className="fa fa-home" />
          <span>Home</span>
        </NavLink>
        <NavLink to="/my-account">
          <i className="fa fa-user" />
          <span>Profile</span>
        </NavLink>
      </NavMenu>
      <LogoutLink to="/" onClick={() => {
        sessionStorage.removeItem('user_id');
        localStorage.removeItem('ss_token');
      }}
      >
        <span>Logout</span>
      </LogoutLink>
    </Nav>
  );
}

export default Navbar;

const Nav = styled.nav`
  justify-content: space-between; /* This will evenly distribute the children */
  height: 6vh;
  background: #6559a2;
  display: flex;
  align-items: center;
  padding: 0 10px;

  @media only screen and (max-width: 600px) {
    height: 7vh;
  }
`;

const Logo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  img {
    width: 6%;
  }

  span {
    font-size: 20px;
    color: white;
    font-weight: bold;
  }

  @media only screen and (max-width: 600px) {
    span {
      display: none;
    }

    img {
      width: 50%;
    }
  }
`;

const NavMenu = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  gap: 40px;

  @media only screen and (max-width: 600px) {
    gap: 15px;
  }

  a {
    text-decoration: none;
    color: white;
    display: flex;
    align-items: center;
    padding: 0 0;
    cursor: pointer;

    i {
      font-size: 20px;
      margin-right: 5px;
    }

    span {
      font-size: 16px;
      letter-spacing: 1.42px;
      position: relative;

      &:after {
        content: '';
        height: 2px;
        background: white;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -6px;
        opacity: 0;
        transform-origin: left center;
        transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
        transform: scaleX(0.5);
      }
    }

    &:hover {
      span:after {
        transform: scaleX(1);
        opacity: 1;
      }
    }
  }
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: white;
  cursor: pointer;

  i {
    font-size: 20px;
    margin-right: 5px;
  }

  span {
    font-size: 16px;
    letter-spacing: 1.42px;
    position: relative;

    &:after {
      content: '';
      height: 2px;
      background: white;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -6px;
      opacity: 0;
      transform-origin: left center;
      transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
      transform: scaleX(0.5);
    }
  }

  &:hover {
    span:after {
      transform: scaleX(1);
      opacity: 1;
    }
  }
`;

const LogoutLink = styled(Link)`
  flex: 1;
  text-decoration: none;
  text-align: right;
  color: white;
  font-size: 16px;
  font-weight: bold;
  // margin-right: 10px;

  i {
    font-size: 14px;
  }
`;